import { render, staticRenderFns } from "./retrievePwd.vue?vue&type=template&id=2a23ba8b&scoped=true"
import script from "./retrievePwd.vue?vue&type=script&lang=js"
export * from "./retrievePwd.vue?vue&type=script&lang=js"
import style0 from "./retrievePwd.vue?vue&type=style&index=0&id=2a23ba8b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a23ba8b",
  null
  
)

export default component.exports